export default __webpack_public_path__ + "static/media/coffee-icon.780a6591.png";